import React from 'react'
import { FlatList, ViewStyle } from 'react-native'
import { Loader } from '../loader'
import { observer } from 'mobx-react-lite'

interface TopicListProps {
  topics: any[]
  loading: boolean
  header?: any
  renderItem?: any
  emptyState?: any
}

export const TopicList = observer((props: TopicListProps) => {
  const { topics, emptyState, header, renderItem, loading } = props

  const keyExtractor = (item: any, index: any) => index.toString()

  return loading ? (
    <Loader />
  ) : (
    <FlatList
      ListHeaderComponent={header || <></>}
      numColumns={2}
      columnWrapperStyle={{ gap: 16 }}
      contentContainerStyle={CONTAINER}
      ListEmptyComponent={emptyState}
      keyExtractor={keyExtractor}
      data={topics}
      extraData={topics?.length}
      renderItem={renderItem}
    />
  )
})

const CONTAINER: ViewStyle = { paddingTop: 8, paddingBottom: 20, paddingHorizontal: 20 }
